<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :multiple-disaster="true" />

    <!--    작업구분-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 작업구분</h5>

      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-3 flex items-center" v-for="(checkbox, checkIndex) in form.inspectionList" :key="checkbox.id" v-if="checkIndex !== 0">
          <div v-if="isPrint || board.readonly" class="flex">
            <div v-if="checkbox.check" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
              <vs-icon icon="check" size="x-small"></vs-icon>
            </div>
            <div v-else style="border: 1px solid #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
              <vs-icon icon="check" size="x-small"></vs-icon>
            </div>
            {{ checkbox.title }}
          </div>
          <label v-else class="flex">
            <vs-checkbox :readonly="board.readonly" v-model="checkbox.check" @change="checkForm"> </vs-checkbox>
            {{ checkbox.title }}
          </label>
        </div>
      </div>
    </div>

    <!--작업허가서 정보-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 작업허가서 정보</h5>

      <div class="writeGridContainer">
        <div>
          <div>작업일자</div>
          <p v-if="isPrint" class="print-input">
            {{ form.inputB_1 }}
          </p>
          <date-selector v-model="form.inputB_1" :readonly="board.readonly" />
        </div>
        <div>
          <div>협력업체명</div>
          <span v-if="isPrint" class="print-input"> {{ form.companyName }} </span>
          <CompanySelector v-else :readonly="board.readonly" v-model="form.inputB_2" placeholder="선택" @select="targetCompany"></CompanySelector>
        </div>
        <div>
          <div>허가번호</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_3 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputB_3" />
        </div>

        <div>
          <div>관리감독자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputB_4" />
        </div>
        <div>
          <div>작업내용</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_5 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputB_5" />
        </div>
        <div>
          <div>작업장소</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_6 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputB_6" />
        </div>

        <div>
          <div>주간작업</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_7 }} ~ {{ form.inputB_8 }}</p>
          <div v-else class="time">
            <time-selector v-model="form.inputB_7" :readonly="board.readonly" />
            <p>~</p>
            <time-selector v-model="form.inputB_8" :readonly="board.readonly" />
          </div>
        </div>
        <div>
          <div>야간연장<br />(18:00 이후)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_9 }} ~ {{ form.inputB_10 }}</p>
          <div v-else class="time">
            <time-selector v-model="form.inputB_9" :readonly="board.readonly" />
            <p>~</p>
            <time-selector v-model="form.inputB_10" :readonly="board.readonly" />
          </div>
        </div>
        <div />
        <div>
          <div>주간인원</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_11 }}</p>
          <comma-input :readonly="board.readonly" v-else v-model="form.inputB_11" />
        </div>
        <div>
          <div>야간인원</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_12 }}</p>
          <comma-input :readonly="board.readonly" v-else v-model="form.inputB_12" />
        </div>
      </div>
    </div>

    <fragment v-for="(inspection, inspection_i) in form.inspectionList" :key="`inspect_${inspection_i}`">
      <!--작업내용-->
      <div v-if="inspection.title === '화기작업' && inspection.check" class="mt-28px">
        <h5 class="mb-4"><i class="dot"></i> 작업내용</h5>
        <div class="writeGridContainer">
          <div>
            <div>부서(회사)명</div>
            <p v-if="isPrint" class="print-input">{{ form.화기작업_작업내역.부서명 }}</p>
            <CompanySelector v-else :readonly="board.readonly" v-model="form.화기작업_작업내역.부서명" placeholder="선택" @select="targetCompany"></CompanySelector>
          </div>
          <div>
            <div>작업명</div>
            <span v-if="isPrint" class="print-input"> {{ form.화기작업_작업내역.작업명 }} </span>
            <ml-input :readonly="board.readonly" v-else v-model="form.화기작업_작업내역.작업명" />
          </div>
          <div>
            <div>작업장소</div>
            <p v-if="isPrint" class="print-input">{{ form.화기작업_작업내역.작업장소 }}</p>
            <ml-input :readonly="board.readonly" v-else v-model="form.화기작업_작업내역.작업장소" />
          </div>
          <div>
            <div>작업일자</div>
            <p v-if="isPrint" class="print-input">{{ form.화기작업_작업내역.작업일자 }}</p>
            <date-selector v-model="form.화기작업_작업내역.작업일자" :readonly="board.readonly" />
          </div>
        </div>

        <div class="writeGridContainer">
          <div>
            <div>화기책임자</div>
            <p v-if="isPrint" class="print-input">{{ form.화기작업_작업내역.화기책임자 }}</p>
            <ml-input :readonly="board.readonly" v-else v-model="form.화기작업_작업내역.화기책임자" />
          </div>
          <div>
            <div>연락처</div>
            <p v-if="isPrint" class="print-input">{{ form.화기작업_작업내역.화기책임자_연락처 }}</p>
            <ml-input :readonly="board.readonly" v-else v-model="form.화기작업_작업내역.화기책임자_연락처" />
          </div>
        </div>

        <div class="writeGridContainer">
          <div>
            <div>화기작업자</div>
            <p v-if="isPrint" class="print-input">{{ form.화기작업_작업내역.화기작업자 }}</p>
            <ml-input :readonly="board.readonly" v-else v-model="form.화기작업_작업내역.화기작업자" />
          </div>
          <div>
            <div>연락처</div>
            <p v-if="isPrint" class="print-input">{{ form.화기작업_작업내역.화기작업자_연락처 }}</p>
            <ml-input :readonly="board.readonly" v-else v-model="form.화기작업_작업내역.화기작업자_연락처" />
          </div>
        </div>

        <div class="writeGridContainer">
          <div>
            <div>화기감시자</div>
            <p v-if="isPrint" class="print-input">{{ form.화기작업_작업내역.화기감시자 }}</p>
            <ml-input :readonly="board.readonly" v-else v-model="form.화기작업_작업내역.화기감시자" />
          </div>
          <div>
            <div>연락처</div>
            <p v-if="isPrint" class="print-input">{{ form.화기작업_작업내역.화기감시자_연락처 }}</p>
            <ml-input :readonly="board.readonly" v-else v-model="form.화기작업_작업내역.화기감시자_연락처" />
          </div>
        </div>
      </div>

      <h5 v-show="inspection.check" class="mt-28px mb-4"><i class="dot"></i> {{ inspection.title }}</h5>
      <table-inspect-merge
        v-show="inspection.check"
        v-for="(list, list_i) in inspection.list"
        :key="`inspect_${inspection_i}_${list_i}`"
        :is-print="isPrint"
        :is-readonly="board.readonly"
        titieType="small"
        :title="list.title"
        :tableHeaderTitle="list.tableHeaderTitle"
        :tableHeaderCheck="[{ text: '적정' }, { text: '미흡' }, { text: '해당없음' }]"
        :tableHeaderNote="[]"
        contentBefore="numbering"
        v-model="form.inspectionList[inspection_i].list[list_i].list"
        :class="[!!list.title && inspection.list.length > list_i + 1 ? 'mb-4' : 'mb-0', inspection.title === '화기작업' && list_i !== 0 && 'adhesion-table']"
      />
    </fragment>

    <!-- 확인자 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 확인자</h5>
      <div class="writeGridContainer">
        <div>
          <div>주무관</div>
          <ml-input v-model="form.sign1.name" :readonly="board.readonly" />
        </div>
        <div>
          <div>서명</div>
          <sign-field v-model="form.sign1.sign" :readonly="board.readonly" />
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>팀장</div>
          <ml-input v-model="form.sign2.name" :readonly="board.readonly" />
        </div>
        <div>
          <div>서명</div>
          <sign-field v-model="form.sign2.sign" :readonly="board.readonly" />
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>과장</div>
          <ml-input v-model="form.sign3.name" :readonly="board.readonly" />
        </div>
        <div>
          <div>서명</div>
          <sign-field v-model="form.sign3.sign" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="mt-28px" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import CompanySelector from "@/components/selector/CompanySelector";
import SignField from "@/components/SignField.vue";
import TableInspectMerge from "@/components/TableInspectMerge";

import inspectData from "./inspectData";

export default {
  components: {
    CompanySelector,
    SignField,
    TableInspectMerge,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},
        typeTitleList: [],

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",
        inputB_8: "",
        inputB_9: "",
        inputB_10: "",
        inputB_11: "",
        inputB_12: "",

        화기작업_작업내역: {
          부서명: "",
          작업명: "",
          작업장소: "",
          작업일자: "",
          화기책임자: "",
          화기책임자_연락처: "",
          화기작업자: "",
          화기작업자_연락처: "",
          화기감시자: "",
          화기감시자_연락처: "",
        },

        worker: [],
        fileList: [],
        companyName: "",

        inspectionList: JSON.parse(JSON.stringify(inspectData)),

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
      },
    };
  },
  computed: {},
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (!this.form || !this.form.inspectionList || this.form.inspectionList.length === 0) {
          this.form.inspectionList = JSON.parse(JSON.stringify(inspectData));
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    if (this.value) {
      const keys = Object.keys(this.value);
      for (const key of keys) {
        if (this.value[key]) {
          this.form[key] = this.value[key];
        }
      }
    }
  },
  methods: {
    checkForm() {
      this.form.typeTitleList = [];
      for (const data of this.form.inspectionList) {
        if (data.check) {
          this.form.typeTitleList.push(data.title);
        }
      }
    },
    updateListCheck(indexList, indexTableRows, indexRows, text) {
      this.form.inspectionList[indexList].list[indexTableRows].list[indexRows].is_checked = text;
    },
    targetCompany(value) {
      this.form.companyName = value.com_name;
    },
  },
};
</script>

<style lang="scss" scoped>
.adhesion-table::v-deep table thead th{
  border-top: 0;
}
</style>
